@for (segment of segments; track segment) {
    @if (segment.toLowerCase() === needle?.toLowerCase()) {
        <mark>{{ segment }}</mark>
    } @else {
        {{ segment }}
    }
}
